import StatCircle from "components/elements/StatCircle";
import { LoansContext } from "providers/loans";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";
import { shortLoanAmount, stringToFullNumber } from "utils/helpers";
import { getCustomCurrency } from "utils/uiconfighelper";

const OriginationsProgress = () => {
  const { user } = useTenant();
  const { loans } = useContext(LoansContext);
  const [total, setTotal] = useState(0);
  const [funded, setFunded] = useState(0);

  useEffect(() => {
    setTotal(
      loans
        .filter((loan: any) => loan.status.isFunded)
        .reduce((acc: number, curr: any) => (acc += stringToFullNumber(curr.amount) || 0), 0)
    );
    let amountFunded = 0;
    loans.forEach((loan: any) => {
      loan.draw_requests.forEach((draw: any) => {
        if (draw.status === "paid") {
          amountFunded += draw.amount;
        }
      });
    });
    setFunded(amountFunded);
  }, [loans]);

  return (
    <StatCircle
      label="Originations"
      description={shortLoanAmount(total.toFixed(2), getCustomCurrency(user))}
      helpNumber={shortLoanAmount((total - funded).toFixed(2), getCustomCurrency(user))}
      helpText="Non-dispersed"
      helpColor="#FC2E53"
      number={Math.round((funded / total) * 100) || 0}
    />
  );
};

export default OriginationsProgress;
